module.exports = __webpack_public_path__ + "img/knight4_04.ed6e94b2.jpg";